<div class="simulation-owner-modal" data-testid="simulation-owner-modal">
  <div class="simulation-owner-modal__header">
    <pr-icon name="download" [width]="20"></pr-icon>
    <h4>Télécharger la simulation</h4>
  </div>

  <p class="simulation-owner-modal__question">À quel nom éditer la simulation ?</p>
  <p class="simulation-owner-modal__hint">
    Le PDF et le document enregistré en GED porteront ce nom.
  </p>

  @if (options$ | async; as options) {
    <div class="simulation-owner-modal__options" role="radiogroup">
      @for (option of options; track option.label) {
        <button
          type="button"
          role="radio"
          class="simulation-owner-modal__option"
          [class.simulation-owner-modal__option--selected]="option === selected"
          [attr.aria-checked]="option === selected"
          (click)="selected = option"
        >
          <span class="simulation-owner-modal__avatars">
            @switch (option.kind) {
              @case ('company') {
                <span class="simulation-owner-modal__avatar simulation-owner-modal__avatar--icon">
                  <pr-icon name="business" [width]="16"></pr-icon>
                </span>
              }
              @case ('couple') {
                @for (member of coupleMembers(option, options); track member.label) {
                  <span class="simulation-owner-modal__avatar">{{ initialsOf(member.label) }}</span>
                }
              }
              @default {
                <span class="simulation-owner-modal__avatar">{{ initialsOf(option.label) }}</span>
              }
            }
          </span>
          <span class="simulation-owner-modal__label">{{ option.label }}</span>
          @if (option === selected) {
            <pr-icon class="simulation-owner-modal__check" name="check" [width]="18"></pr-icon>
          }
        </button>
      }
    </div>
  }

  <div class="simulation-owner-modal__actions">
    <pr-button size="lg" label="Annuler" data-testid="simulation-owner-modal-cancel" (onClick)="cancel()"></pr-button>
    <pr-button
      data-testid="simulation-owner-modal-confirm"
      size="lg"
      display="neutral"
      label="Télécharger"
      [disabled]="!selected"
      (onClick)="confirm()"
    ></pr-button>
  </div>
</div>
